
import { systemCode, xs_languageCode } from "../..";

/*
export function getUrlPathSeo(data) {
    try {
        const seoSettings = data && data.seoSettings?JSON.parse(data.seoSettings):null;
        const seoSettingSysCodeLang = seoSettings && (seoSettings[systemCode]?seoSettings[systemCode]:seoSettings['DEFAULT'])?.[xs_languageCode];
        return (seoSettingSysCodeLang && seoSettingSysCodeLang.pn) || seoSettingSysCodeLang;
    } catch(err) {
        console.log(err);
    }

    return null;
}
*/

export function getUrlPathSeo(data) {
    try {
        const seoSettings = data && data.seoSettings?JSON.parse(data.seoSettings):null;
        const seoSettingByDefault = seoSettings && (seoSettings['DEFAULT'])?.[xs_languageCode];
        const seoSettingBySysCode = seoSettings && (seoSettings[systemCode])?.[xs_languageCode];
        const pathSeoByDefault = seoSettingByDefault && seoSettingByDefault.pn;
        const pathSeoBySysCode = seoSettingBySysCode && seoSettingBySysCode.pn;
        return pathSeoBySysCode || pathSeoByDefault || seoSettingBySysCode || seoSettingByDefault;
    } catch(err) {
        console.error(err);
    }

    return null;
}
